export type HttpClient = typeof fetch;

export interface BrowserInterface {
  userAgent(): string;
}

export class NullBrowserInfo implements BrowserInterface {
  userAgent(): string {
    console.warn('Using a null service - is this intended?');
    return 'no-user-agent';
  }
}

export class BrowserInfo implements BrowserInterface {
  userAgent(): string {
    return window.navigator.userAgent;
  }
}
